import { LogOut } from 'lucide-react-native';
import { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Button } from '../../../components/primitives/Button';
import { HStack, VStack } from '../../../components/primitives/Stack';
import { Text } from '../../../components/primitives/Text';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { SettingsSection } from './SettingsSection';

export function AccountSection() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = async () => {
    if (isSigningOut) return;
    setIsSigningOut(true);
    try {
      await logout();
    } finally {
      setIsSigningOut(false);
    }
  };

  return (
    <SettingsSection
      title={t('settings.account.title')}
      preamble={t('settings.account.preamble')}
      description={t('settings.account.description')}
    >
      <VStack spacing="md">
        <Button
          variant="primary"
          onPress={handleSignOut}
          loading={isSigningOut}
          disabled={isSigningOut}
          style={styles.signOutButton}
          accessibilityLabel={t('settings.account.signOut')}
          testID="settings_sign_out_button"
        >
          <HStack spacing="sm" align="center">
            <LogOut size={18} color={colors.text.primary} />
            <Text variant="body" weight="medium" color={colors.text.primary}>
              {isSigningOut ? t('settings.account.signOutLoading') : t('settings.account.signOut')}
            </Text>
          </HStack>
        </Button>
      </VStack>
    </SettingsSection>
  );
}

const styles = StyleSheet.create({
  signOutButton: {
    backgroundColor: colors.status.error.main,
    alignSelf: 'flex-start',
  },
});
